






















































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import GameBody from '@/components/Table/GameBody.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import GameReportData from '@/data/GameReportData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    GameBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  Criteria = {
    ...this.Period,
  };

  gameType = 'total';

  TableHeadGameReport: any = [...GameReportData.TableHeadGameReport];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  BreadcrumbList: any = [
    {
      type: 'amb',
      username: 'amb',
    },
  ];

  currentState = 'amb';

  previousState = 'amb';

  provider = '';

  dataList: any[] = [];

  dataFooter: any[] = [];

  totalList: any[] = [];

  startDate = '';

  endDate = '';

  created() {
    this.provider = 'ambpoker';
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    this.TableHeadGameReport = [...GameReportData.TableHeadGameReport];
    const criteria = {
      ...this.Period, gameType: this.gameType, state: this.currentState, provider: this.provider,
    };
    const res = await this.ReportInstance.FetchGameReport(criteria);
    if (res.code) {
      this.checkError(res);
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type !== this.previousState);
      this.currentState = this.previousState;
      this.GeneralInstance.toggleLoading(false);
      return false;
    }
    if (this.currentState === 'amb') {
      this.dataList = [this.ReportInstance.dataGame];
      this.dataFooter = { ...this.ReportInstance.dataGame };
      this.TableHeadGameReport[0][0].displayName = `report.gameReport.datatable.${this.currentState}`;
    } else if (this.currentState === 'provider') {
      this.dataList = [...this.ReportInstance.dataGame.report];
      this.dataFooter = { ...this.ReportInstance.dataGame.footer };
      this.TableHeadGameReport[0][0].displayName = `report.gameReport.datatable.${this.currentState}`;
    } else if (this.currentState === 'type') {
      const mapTable = [...GameReportData.TableHeadGameReport[0]];
      mapTable.join();
      mapTable.splice(1, 0, {
        displayName: 'report.gameReport.datatable.type',
        attr: {
          class: 'text-center',
        },
      });
      this.TableHeadGameReport[0] = [...mapTable];
      this.dataList = [...this.ReportInstance.dataGame.report];
      this.dataFooter = { ...this.ReportInstance.dataGame.footer };
    } else if (this.currentState === 'game') {
      const mapTable = [...GameReportData.TableHeadGameReport[0]];
      mapTable.join();
      mapTable.splice(1, 0, {
        displayName: 'report.gameReport.datatable.game',
        attr: {
          class: 'text-center',
        },
      });
      this.TableHeadGameReport[0] = [...mapTable];
      this.TableHeadGameReport[0][0].displayName = 'report.gameReport.datatable.type';
      this.dataList = [...this.ReportInstance.dataGame.report];
      this.dataFooter = { ...this.ReportInstance.dataGame.footer };
    }
    if (res.code) {
      this.checkError(res);
      this.GeneralInstance.toggleLoading(false);
      return false;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchGame();
  }

  onSubmit() {
    this.fetchGame();
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
    };
  }

  handleChange() {
    if (this.gameType === 'total') {
      this.currentState = 'amb';
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type === 'amb');
    } else {
      this.currentState = 'game';
      this.BreadcrumbList = [
        {
          type: 'amb',
          username: 'amb',
        },
        {
          type: 'provider',
          username: this.provider,
        },
        {
          type: 'game',
          username: this.gameType,
        },
      ];
    }
    this.fetchGame();
  }

  handleBreadcrumb(item) {
    if (item.type === 'game') return false;
    if (item.type === 'provider') {
      this.TableHeadGameReport[0][0].displayName = 'report.gameReport.datatable.provider';
      this.currentState = 'type';
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type !== 'game');
    } else {
      this.currentState = item.type;
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type === item.type);
    }
    this.gameType = 'total';
    this.fetchGame();
  }

  handleSub(item, currentState) {
    this.previousState = currentState;
    if (currentState === 'amb') {
      this.currentState = 'provider';
    } else if (currentState === 'provider') {
      this.provider = item.game;
      this.BreadcrumbList.push({
        type: 'provider',
        username: item.game,
      });
      this.currentState = 'type';
    } else if (currentState === 'type') {
      this.gameType = item.game;
      this.BreadcrumbList.push({
        type: 'game',
        username: item.game,
      });
      this.currentState = 'game';
    }
    this.fetchGame();
  }
}
